import React from 'react';
import { Link } from 'react-router-dom';
import { useCart } from '../context/CartContext';
import './Cart.css';

export default function Cart({ open, onClose }) {
  const { items, total, count, dispatch } = useCart();

  const updateQty = (key, qty) => dispatch({ type: 'UPDATE_QTY', payload: { key, qty } });
  const remove = (key) => dispatch({ type: 'REMOVE_ITEM', payload: key });

  return (
    <>
      <div className={`cart-overlay ${open ? 'open' : ''}`} onClick={onClose} />
      <aside className={`cart-drawer ${open ? 'open' : ''}`}>
        <div className="cart-header">
          <div>
            <h2 className="cart-title">Your Bag</h2>
            {count > 0 && <p className="cart-subtitle">{count} {count === 1 ? 'piece' : 'pieces'} selected</p>}
          </div>
          <button className="cart-close" onClick={onClose} aria-label="Close cart">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
              <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
            </svg>
          </button>
        </div>

        {items.length === 0 ? (
          <div className="cart-empty">
            <div className="empty-icon">
              <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1">
                <path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/>
                <line x1="3" y1="6" x2="21" y2="6"/>
                <path d="M16 10a4 4 0 01-8 0"/>
              </svg>
            </div>
            <p className="empty-text">Your bag is empty</p>
            <p className="empty-sub">Begin your story</p>
            <button className="btn-primary" onClick={onClose} style={{marginTop: '1.5rem'}}>
              <Link to="/shop">Explore Collection</Link>
            </button>
          </div>
        ) : (
          <>
            <div className="cart-items">
              {items.map(item => (
                <div className="cart-item" key={item.key}>
                  <div className="cart-item-img">
                    <img src={item.image} alt={item.name} />
                  </div>
                  <div className="cart-item-info">
                    <h4 className="cart-item-name">{item.name}</h4>
                    <p className="cart-item-size">Size: {item.size}</p>
                    <p className="cart-item-price">€{item.price}</p>
                    <div className="cart-item-qty">
                      <button onClick={() => updateQty(item.key, item.quantity - 1)} className="qty-btn">−</button>
                      <span className="qty-val">{item.quantity}</span>
                      <button onClick={() => updateQty(item.key, item.quantity + 1)} className="qty-btn">+</button>
                    </div>
                  </div>
                  <button className="cart-remove" onClick={() => remove(item.key)} aria-label="Remove item">
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                      <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
                    </svg>
                  </button>
                </div>
              ))}
            </div>
            <div className="cart-footer">
              <div className="cart-total-row">
                <span className="total-label">Total</span>
                <span className="total-amount">€{total.toFixed(2)}</span>
              </div>
              <p className="cart-shipping">Complimentary shipping on orders over €250</p>
              <Link to="/checkout" className="btn-primary checkout-btn" onClick={onClose}>
                Proceed to Checkout
              </Link>
              <button className="btn-secondary" onClick={onClose}>
                <Link to="/shop">Continue Shopping</Link>
              </button>
            </div>
          </>
        )}
      </aside>
    </>
  );
}
